module.exports = __webpack_public_path__ + "0f512709414c3ea230534eb80f3f743a.jpg";